// extracted by mini-css-extract-plugin
export default {"wrapper":"BdbAFL","withIcons":"ijWfut","ltr":"TD46oG","user":"xzldRa","rtl":"YRgf21","name":"dI69aw","arrow":"GVjl6y"};